import React from 'react';

import { ChevronLeft, SvgIconLight } from '@r-client/shared/ui/icons';

import { Box, Link, Text } from '../../../';

export interface IBackLinkProps {
  href: string;
  label: string;
}

export const BackLink: React.FC<React.PropsWithChildren<IBackLinkProps>> = ({
  href,
  label,
}) => {
  return (
    <Link href={href} variant={Link.variants.inherit}>
      <Text as="span" color="gray2" type="bodyBig" weight="300">
        <Box as="span" m={Box.right(0.5)}>
          <SvgIconLight icon={ChevronLeft} />
        </Box>
        {label}
      </Text>
    </Link>
  );
};
